import { NavController, NavParams } from 'ionic-angular';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'show-modal',
  templateUrl: 'show-modal.html'
})
export class CountdownComponent {

  counter = 10;
  interval;
  countdownBg = CountdownBg.FOREST;
  noGpsSignal = false;
  lowGpsSignal = true;
  highGpsSignal = false;
  showCountDown;

  constructor(
    public navController: NavController,
    public navParams: NavParams,
    public translate: TranslateService
  ) {
    this.countdownBg = navParams.get('countdownBg');
    this.checkGpsSignal();
    this.onCloseTimer();
  }

  onCloseTimer() {
    this.interval = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter === 0) {
        clearInterval(this.interval)
        this.navController.pop();
      }
    }, 1000)
  }

  checkGpsSignal() {//bohdan
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.clearSignals();
        if (position.coords.accuracy < 50) {
          this.lowGpsSignal = true;
        } else if (position.coords.accuracy >= 50) {
          this.highGpsSignal = true;
        }
      });
    }
    else {
      this.clearSignals();
      this.noGpsSignal = true;
    }
  }

  clearSignals() {
    this.noGpsSignal = this.lowGpsSignal = this.highGpsSignal = false;
  }

  onCloseModal() {
    this.navController.pop();
    clearInterval(this.interval)
  }
}


export enum CountdownBg {
  APPLAUSE,
  FOREST
}


// WEBPACK FOOTER //
// /src/components/show-modal/show-modal.ts